import { render, staticRenderFns } from "./AmountDetailOrder.vue?vue&type=template&id=3b5f759c&scoped=true&"
import script from "./AmountDetailOrder.vue?vue&type=script&lang=ts&"
export * from "./AmountDetailOrder.vue?vue&type=script&lang=ts&"
import style0 from "./AmountDetailOrder.vue?vue&type=style&index=0&id=3b5f759c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5f759c",
  null
  
)

export default component.exports